export default __webpack_public_path__ + "static/parent-reviews-04565979d4661506f62c36a2a142a5b3.png";